import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface AppWindow extends Window {}

export const appWindow: AppWindow = window as unknown as AppWindow;
export const APP_WINDOW = new InjectionToken<AppWindow>('AppWindow');
